
import React from 'react'; // Removed useState
import { AddressSection } from '../../../addBusinessModal';
import { FormSection } from '../';
import { useBusinessFormContext } from '@/context/BusinessFormContext';

interface AddressFormSectionProps {}

const AddressFormSection: React.FC<AddressFormSectionProps> = () => {
  const {
    businessDetails,
    handleInputChange,
    handleSelectChange,
    addressOpen,
    setAddressOpen,
    addressComplete,
    addressEdited,
    addressHasChanges,
    saveAddress, // Use context's saveAddress directly
    isSavingAddress, // Use context's loading state
  } = useBusinessFormContext();

  // Local isProcessing state and handleSave wrapper are no longer needed.

  return (
    <FormSection
      number={2}
      title="Address"
      open={addressOpen}
      onOpenChange={setAddressOpen}
      isCompleted={addressEdited}
      isDisabled={false} 
      isComplete={addressComplete}
      isEdited={addressEdited} 
      hasUnsavedChanges={addressHasChanges}
      onSave={saveAddress} // Pass context's saveAddress directly
      isProcessing={isSavingAddress} // Pass context's loading state
    >
      <AddressSection
        businessDetails={businessDetails}
        handleInputChange={handleInputChange}
        handleSelectChange={handleSelectChange}
      />
    </FormSection>
  );
};

export default AddressFormSection;
